/**
 * Three-button OAuth row used by Login and Signup. Shared so the
 * visual (Google + GitHub + Microsoft, side by side) lives in one
 * place. Buttons render unconditionally; whichever providers the
 * server has env vars for will succeed at sign-in time. The others
 * 404 against `/api/auth/sign-in/social` until configured — see
 * `apps/server/src/infrastructure/auth/betterAuth.ts` for the
 * conditional registration block.
 *
 * The `disabled` prop disables ALL buttons together — calling code
 * sets it during in-flight redirects so a fast double-click can't fire
 * two `window.location` assignments.
 */
import { Github } from 'lucide-react'
import { Button } from '@/components/ui'
import { GoogleIcon } from '@/auth/GoogleIcon'
import { MicrosoftIcon } from '@/auth/MicrosoftIcon'

export type OAuthProvider = 'google' | 'github' | 'microsoft'

export interface OAuthRowProps {
  onSelect: (provider: OAuthProvider) => void
  disabled?: boolean
}

export function OAuthRow({ onSelect, disabled }: OAuthRowProps) {
  return (
    <div className="grid grid-cols-3 gap-2">
      <Button
        variant="outline"
        type="button"
        onClick={() => onSelect('google')}
        disabled={disabled}
        className="w-full"
      >
        <GoogleIcon className="h-4 w-4 mr-2" /> Google
      </Button>
      <Button
        variant="outline"
        type="button"
        onClick={() => onSelect('github')}
        disabled={disabled}
        className="w-full"
      >
        <Github className="h-4 w-4 mr-2" /> GitHub
      </Button>
      <Button
        variant="outline"
        type="button"
        onClick={() => onSelect('microsoft')}
        disabled={disabled}
        className="w-full"
      >
        <MicrosoftIcon className="h-4 w-4 mr-2" /> Microsoft
      </Button>
    </div>
  )
}
